import {ApiClient} from '@hconnect/apiclient'
import {PlantRunningTimesDto as PlantRunningTimes, Iso8601} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {stringify} from 'query-string'

import {QueryKey} from '../../types'

type Params = {
  plantIds: string[]
  from: Iso8601
  to: Iso8601
}

export const usePlantsRunningTimes = <TSelect = PlantRunningTimes[]>(
  {from, to, plantIds}: Params,
  options?: Omit<UseQueryOptions<PlantRunningTimes[], AxiosError, TSelect>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<PlantRunningTimes[], AxiosError, TSelect>({
    queryKey: [QueryKey.PlantsRunningTimes, from, to, plantIds],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<PlantRunningTimes[]>(
        '/runningtimes-orchestrator/running-times',
        {
          params: {from, to, plantIds},
          paramsSerializer: (params: string[]) => stringify(params, {arrayFormat: 'none'}),
          signal
        }
      )
      return response.data
    },
    ...options
  })
}
